module.exports = __webpack_public_path__ + "img/lot_brush_street_cars.0123bad6.jpg";